/**
 * @generated SignedSource<<62c47996bbc4ef405dc775ecfc514550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CalendarQuery$variables = {
  gameFilter?: string | null;
  month: number;
  year: number;
};
export type CalendarQuery$data = {
  readonly dailiesForAMonth: ReadonlyArray<{
    readonly day: any;
    readonly puzzles: ReadonlyArray<{
      readonly puzzle: {
        readonly currentAccountGamePlayed: {
          readonly completed: boolean;
          readonly pointsAwarded: number;
          readonly slug: string;
        } | null;
        readonly game: {
          readonly displayName: string;
          readonly slug: string;
        };
        readonly name: string | null;
        readonly slug: string;
      };
    }>;
  }>;
};
export type CalendarQuery = {
  response: CalendarQuery$data;
  variables: CalendarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "gameFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "year"
},
v3 = [
  {
    "kind": "Variable",
    "name": "gameFilter",
    "variableName": "gameFilter"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  {
    "kind": "Variable",
    "name": "year",
    "variableName": "year"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pointsAwarded",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Daily",
        "kind": "LinkedField",
        "name": "dailiesForAMonth",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PuzzleDaily",
            "kind": "LinkedField",
            "name": "puzzles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Puzzle",
                "kind": "LinkedField",
                "name": "puzzle",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Game",
                    "kind": "LinkedField",
                    "name": "game",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GamePlayed",
                    "kind": "LinkedField",
                    "name": "currentAccountGamePlayed",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CalendarQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Daily",
        "kind": "LinkedField",
        "name": "dailiesForAMonth",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PuzzleDaily",
            "kind": "LinkedField",
            "name": "puzzles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Puzzle",
                "kind": "LinkedField",
                "name": "puzzle",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Game",
                    "kind": "LinkedField",
                    "name": "game",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GamePlayed",
                    "kind": "LinkedField",
                    "name": "currentAccountGamePlayed",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90eda572109ec3ab0117dd424bc50998",
    "id": null,
    "metadata": {},
    "name": "CalendarQuery",
    "operationKind": "query",
    "text": "query CalendarQuery(\n  $month: Int!\n  $year: Int!\n  $gameFilter: String\n) {\n  dailiesForAMonth(month: $month, year: $year, gameFilter: $gameFilter) {\n    day\n    puzzles {\n      puzzle {\n        slug\n        name\n        game {\n          slug\n          displayName\n          id\n        }\n        currentAccountGamePlayed {\n          slug\n          completed\n          pointsAwarded\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "344335545b750fc3bb2324838236d34f";

export default node;
